import {Component, Input, OnChanges, OnInit} from '@angular/core';

@Component({
  selector: 'ui-tab-panel',
  template: `<div class="tab-pane" [attr.id]="'tab'+index" [ngClass]="{'active show':isOpen}" role="tabpanel"
     aria-labelledby="home-tab">
  <ng-content></ng-content>
</div>
`,
  styles: [`.tab-pane{display:none}.tab-pane.active{display:block}`]
})
export class TabPanelComponent implements OnInit, OnChanges {

  @Input() header;
  @Input() isOpen;
  index;

  constructor() {
  }

  ngOnChanges(){
    if(this.isOpen){
      console.log(this.isOpen);
    }
  }

  ngOnInit() {
    this.index = Math.ceil(1000 * Math.random());
  }



}
